import baseEvents from './../../../base/config/baseEvents';
import flightStopTypes from './../../../flights/flight-stop-types';

export default function AtcFiltersController(
    $scope,
    $window,
    $timeout,
    $rootScope,
    scrollService,
    atcFlightsFactory,
    atcFlightFiltersService,
) {
    'ngInject';

    const vm = this;
    let applyComparisonFilter = false;
    let previousFlightNumberValue;

    Object.assign(vm, {
        showStops: true,
        showPrice: true,
        showAirlines: true,
        showTimes: true,
        showAirports: true,
        isArrivalTimesVisible: false,
        showFlightNumber: true,
        $onInit,
        benefitFiltersExists,
        baggageFiltersExists,
        changeableFiltersExists,
        refundableFiltersExists,
        ticketValidityFiltersExists,
        resetToDefault,
        hasFiltersChanged,
        submitHotelNameField,
        onBlurFlightNumberField,
        toggleFlightNumberHoveredState,
        submitHotelNameFieldManual,
        isFlightNumberClearIconVisible,
        clearFlightNumberField,
    });

    function $onInit() {
        const {Filters: filters} = atcFlightsFactory.getFlights();
        Object.assign(vm, atcFlightFiltersService.getProcessedFilters(angular.copy(filters)));
        vm.initialRawFilters = angular.copy(filters);
        vm.initialParsedFilters = angular.copy(vm.updateFilters);
        vm.durationMinimum = vm.filters.minimumDuration;
        vm.durationMaximum = vm.filters.maximumDuration;
        vm.stopoverMinimum = vm.filters.minimumStopover;
        vm.stopoverMaximum = vm.filters.maximumStopover;
        vm.flightNumberFilterForm = {
            text: '',
        };
        watchFilters();
        subscribe();
    }

    function subscribe() {
        $scope.$on(baseEvents.COMPARISON_FILTER, (event, {comparisonFilter, airline, isDirect}) => {
            applyComparisonFilter = true;
            Object.assign(vm.updateFilters, {
                comparisonFilter,
                airlines: [airline],
                ...(angular.isDefined(isDirect) ? {flightStopsType: getStopsFilter(isDirect)} : {}), //apply flightStopsType filter only if it`s needed
            });

            function getStopsFilter(isDirectFlight) {
                    const {DIRECT, ONE_STOP, MULTI_STOP} = flightStopTypes;
                    return isDirectFlight ? [DIRECT] : [ONE_STOP, MULTI_STOP];
            }
        });
        $scope.$on(baseEvents.CLEAR_FILTERS, resetToDefault);
        $scope.$on(baseEvents.UPDATE_FILTERS, function(event, data) {
            const filters = Object.values(data);
            updateFlightNumbers((filters[0] || {}).FlightNumber);
        });
    }

    function updateFlightNumbers(data) {
        vm.filters.flightNumber = data;
    }

    function resetToDefault() {
        clearFlightNumberField();
        atcFlightFiltersService.flightIsSelected = false;
        $rootScope.$broadcast(baseEvents.FLIGHT_CLEAR_FILTERS_ENDED);
        Object.assign(vm, atcFlightFiltersService.getProcessedFilters(angular.copy(vm.initialRawFilters)));
    }

    function hasFiltersChanged() {
        return !angular.equals(vm.initialParsedFilters, vm.updateFilters) || !!atcFlightFiltersService.flightIsSelected;
    }

    function applyFilters(newFilters) {
        const appliedFilters = angular.copy(newFilters);
        if (!applyComparisonFilter) {
            appliedFilters.comparisonFilter = null;
        }
        atcFlightFiltersService.applyFilters(appliedFilters);
        scrollService.scrollToTop();
        applyComparisonFilter = false;
    }

    function watchFilters() {
        $scope.$watch(() => vm.updateFilters, handleFiltersChange, true);
    }

    function handleFiltersChange(newFilters, oldFilters) {
        $scope.filtersChange.changed = hasFiltersChanged();
        if (!angular.equals(newFilters, oldFilters)) {
            applyFilters(newFilters);
        }
    }

    function baggageFiltersExists() {
        return vm.filters.baggageAllowance.length > 1;
    }

    function changeableFiltersExists() {
        return vm.filters.changeable.length > 1;
    }

    function refundableFiltersExists() {
        return vm.filters.refundable.length > 1;
    }

    function ticketValidityFiltersExists() {
        return vm.filters.ticketValidity.length;
    }

    function benefitFiltersExists() {
        return baggageFiltersExists()
            || changeableFiltersExists()
            || refundableFiltersExists()
            || ticketValidityFiltersExists();
    }

    function toggleFlightNumberHoveredState(isActive) {
        vm.flightNumberFocused = isActive;
    }

    function hasNameFailValidation() {
        if (vm.flightNumberFilterForm.$invalid) {
            return true;
        }

        if (angular.isDefined(vm.flightNumberFilterForm.text) && !vm.flightNumberFilterForm.text.length && !vm.flightNumberFilterForm.$submitted) {
            return true;
        }
        return previousFlightNumberValue === vm.flightNumberFilterForm.text;
    }

    function isFlightNumberClearIconVisible() {
        return !!(previousFlightNumberValue
            && previousFlightNumberValue.length
            && vm.flightNumberFilterForm.text
            && vm.flightNumberFilterForm.text.length);
    }


    function submitHotelNameFieldManual() {
        if (vm.updateFilters) {
            const item = vm.flightNumberFilterForm.text;
            vm.updateFilters.flightNumber = item.toUpperCase();
        }
    }

    function submitHotelNameField($item) {
        if (hasNameFailValidation()) {
            return;
        }
        previousFlightNumberValue = vm.flightNumberFilterForm.text;

        const flightNumber = $item
            ? $item
            : vm.flightNumberFilterForm.text;

        const arr = angular.copy(vm.filters.flightNumber);

        if (arr.indexOf(flightNumber) !== -1) {
            const chosenFilters = {flightNumber};
            if (vm.updateFilters) {
                delete vm.updateFilters.flightNumber;
                Object.assign(chosenFilters, vm.updateFilters);
            }

            const item = vm.flightNumberFilterForm.text;
            vm.updateFilters.flightNumber = item.toUpperCase();
        }
    }
    function onBlurFlightNumberField() {
        if (vm.flightNumberFocused) {
            return;
        }
        vm.submitHotelNameField();
    }
    function clearFlightNumberField() {
        previousFlightNumberValue = '';
        vm.flightNumberFilterForm.text = '';
        vm.updateFilters.flightNumber = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-flights-view/filters/flight-filters-controller.js